const COMPACT_SUFFIXES: { value: number, suffix: string }[] = [
  { value: 1e9, suffix: 'B' },
  { value: 1e6, suffix: 'M' },
  { value: 1e3, suffix: 'K' },
];

const EMPTY_CURRENCY_VALUE = '—';

const formatCompactCurrency = (raw: number | string | null | undefined): string => {
  if (raw === null || raw === undefined) return EMPTY_CURRENCY_VALUE;

  const rawValue = String(raw).trim();

  if (!rawValue) return EMPTY_CURRENCY_VALUE;

  const numeric = parseFloat(rawValue.replace(/[^0-9.-]/g, ''));

  if (Number.isNaN(numeric)) return rawValue;

  const isNegative = numeric < 0;
  const abs = Math.abs(numeric);

  const match = COMPACT_SUFFIXES.find(({ value }) => abs >= value);

  if (!match) {
    return `${isNegative ? '-' : ''}$${abs.toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
  }

  const divided = abs / match.value;
  const formatted = divided % 1 === 0
    ? divided.toFixed(0)
    : divided.toFixed(1).replace(/\.0$/, '');

  return `${isNegative ? '-' : ''}$${formatted}${match.suffix}`;
};

export default formatCompactCurrency;
